/* eslint-disable tsdoc/syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable tsdoc/syntax */
import { useCallback, useEffect, useState } from "react";

import Clock from "@zenith/assets/icons/Clock";
import CloseCircle from "@zenith/assets/icons/CloseCircle";
import CircularProgress from "@mui/material/CircularProgress";
import {
  AutocompleteComponent,
  DropZoneComponent,
  ModalComponent,
  SelectComponent,
  SpinnerComponent,
  TextFieldComponent,
} from "@zenith/components";
import { SelectItemsType } from "@zenith/components/ui/SelectComponent/select-component/interfaces";
import { useUpgradeContext, useUserDetailsContext } from "@zenith/context";
import {
  FILE_INVALID_TYPE_BACK_OFFICE,
  MIN_SIZE_BACK_OFFICE,
  ONLY_CHARACTERS_NUMBERS_AND_SPACES_REGEX,
  SECTOR_SUB_CATEGORIES_LIMIT,
  UPGRADE_REG_DETAILS_KEY,
} from "@zenith/data/constants";
import StepStatusComponent from "@zenith/features/Tiers/components/StepStatusComponent/step-status-component/step-status-component";
import {
  setBusinessDescriptionValidations,
  setBusinessSectorValidations,
} from "@zenith/features/Tiers/validations/BusinessDetailsValidations";
import { AppNavigation, AppStepper, usePolling, TierStepper } from "@zenith/hooks";
import { UPGRADE_ACCOUNT } from "@zenith/routes/paths";
import {
  ApiResponseDTOBusinessDetailsResponseDTO,
  ApiResponseDTOBusinessSectorsResponseDTO,
  ApiResponseDTODiscardUpgradeResponseDTO,
  ApiResponseDTOListBusinessTypeDTO,
  ApiResponseDTORegistrationDetailsRequestDTO,
  BusinessApiService,
  BusinessDetailsNigeriaDTO,
  BusinessDetailsResponseDTO,
  BusinessTypeDTO,
  DocumentDetailsRequestDTO,
  TierApiService,
  TierStepsResponseDTO,
  UsersApiService,
} from "@zenith/services/user";
import type { BusinessSubCategorySuggestionDTO } from "@zenith/services/user/models/BusinessSubCategorySuggestionDTO";
import { removeBase64Prefix } from "@zenith/utils/Formaters";
import { updateTierStepStatus } from "@zenith/utils/Helpers";
import { getFileExtension } from "@zenith/utils/Helpers/getFileExtension";
import { FormDataFields, FormErrorsType } from "./interfaces";
import CheckCircle from "@zenith/assets/icons/CheckCircle";

/* eslint-disable-next-line */
export interface BusinessDetailsPageProps {
  step: TierStepsResponseDTO;
  tier: string;
}

type BusinessSectorDTO = {
  name?: string;
  requiresScuml?: boolean;
  sectorId?: number;
  mccCode?: string;
};

interface ExtendedBusinessDetailsResponseDTO {
  verificationStatus?: BusinessDetailsResponseDTO.verificationStatus;
  verificationStatusCode?: string;
}

export function BusinessDetailsPage(props: BusinessDetailsPageProps) {
  const {
    step: { stepStatus },
  } = props;

  const { setActiveStep } = AppStepper();
  const { goToNextOpenStep } = TierStepper();
  const { navigateTo } = AppNavigation();
  const { upgradeContext, setUpgradeContext, clearUpgradeContext } =
    useUpgradeContext();
  const { userDetailsContext } = useUserDetailsContext();

  const businessDetailsInitialStatus = upgradeContext.isRecoveryFlow
    ? stepStatus
    : undefined;
  const [backModal, setBackModal] = useState<boolean>(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState<boolean>(false);
  const [businessDetailsStartPage, setBusinessDetailsStartPage] =
    useState<boolean>(!upgradeContext.isRecoveryFlow);
  const [businessDetailsStatus, setBusinessDetailsStatus] = useState<
    string | undefined
  >(businessDetailsInitialStatus);
  const [
    businessDetailsValidationTrigger,
    setBusinessDetailsValidationTrigger,
  ] = useState<boolean>(false);
  const [verifyingBusinessDetails, setVerifyingBusinessDetails] =
    useState<boolean>(!upgradeContext.isRecoveryFlow);
  const [matchedType, setMatchedType] = useState<BusinessTypeDTO | undefined>(
    undefined
  );
  const [matchedSector, setMatchedSector] = useState<
    BusinessSectorDTO | undefined
  >(undefined);
  const [isMatchedSector, setIsMatchedSector] = useState<boolean>(false);
  const [isMatchedType, setIsMatchedType] = useState<boolean>(false);
  const [isScrumLRequired, setIsScrumLRequired] = useState<boolean>(false);
  const [selectedBusinessType, setSelectedBusinessType] = useState<string>("");
  const [selectedBusinessSector, setSelectedBusinessSector] =
    useState<string>("");
  const [businessSectorItems, setBusinessSectorItems] = useState<
    SelectItemsType[]
  >([]);
  const [businessSectorData, setBusinessSectorData] = useState<
    BusinessSectorDTO[]
  >([]);
  const [businessTypeData, setBusinessTypeData] = useState<BusinessTypeDTO[]>(
    []
  );
  const [subCategories, setSubCategories] = useState<
    BusinessSubCategorySuggestionDTO[]
  >([]);
  const [isLoadingSubCategories, setIsLoadingSubCategories] =
    useState<boolean>(false);
  const [selectedSubCategoryId, setSelectedSubCategoryId] =
    useState<string>("");
  const [documentsArray, setDocumentsArray] = useState<
    DocumentDetailsRequestDTO[]
  >([]);
  const [verificationStatusCode, setVerificationStatusCode] = useState<
    string | null
  >(null);
  const [has1015Error, setHas1015Error] = useState<boolean>(false);
  const [isResubmissionMode, setIsResubmissionMode] = useState<boolean>(false);
  const [rejectedDocumentTypes, setRejectedDocumentTypes] = useState<string[]>(
    []
  );

  const initialFormData = {
    businessName: "",
    businessDescription: "",
    businessType: "",
    businessSector: "",
  };

  const [formData, setFormData] = useState<FormDataFields>(initialFormData);

  const initialFormErrors = {
    businessName: { hasError: false, message: "" },
    businessDescription: { hasError: false, message: "" },
    businessType: { hasError: false, message: "" },
    businessSector: { hasError: false, message: "" },
  };

  const [formErrors, setFormErrors] =
    useState<FormErrorsType>(initialFormErrors);

  const selectedSubCategory = subCategories.find(
    (subCategory) => String(subCategory.subCategoryId) === selectedSubCategoryId
  );

  useEffect(() => {
    const findMatchedType = businessTypeData.find(
      (type) => type.typeValue === selectedBusinessType
    );

    const findMatchedSector = businessSectorData.find(
      (sector) => sector.name === selectedBusinessSector
    );

    // SCUML is required for specific sectors when business type is NOT "Clubs, Societies & Associations"
    const isSrumLRequired =
      (selectedSubCategory?.requiresScuml ??
        findMatchedSector?.requiresScuml) &&
      findMatchedType?.typeName !== "Clubs, Societies & Associations";

    setMatchedType(findMatchedType);
    setIsMatchedType(Boolean(findMatchedType));
    setIsScrumLRequired(isSrumLRequired || false);

    setMatchedSector(findMatchedSector);
    setIsMatchedSector(Boolean(findMatchedSector));
  }, [
    selectedBusinessType,
    businessTypeData,
    selectedBusinessSector,
    businessSectorData,
    selectedSubCategory,
  ]);

  useEffect(() => {
    if (!matchedSector?.name) {
      setSubCategories([]);
      return;
    }

    let isCurrent = true;
    setIsLoadingSubCategories(true);
    BusinessApiService.searchBusinessSubCategories(
      matchedSector.name,
      SECTOR_SUB_CATEGORIES_LIMIT
    )
      .then((response) => {
        if (!isCurrent) return;
        setSubCategories(
          (response.data?.suggestions ?? []).filter(
            (suggestion) =>
              suggestion.sectorId === matchedSector.sectorId &&
              suggestion.subCategoryId !== undefined
          )
        );
      })
      .catch((error) => {
        console.error("Error fetching sector sub-categories:", error);
        if (isCurrent) setSubCategories([]);
      })
      .finally(() => {
        if (isCurrent) setIsLoadingSubCategories(false);
      });

    return () => {
      isCurrent = false;
    };
  }, [matchedSector?.sectorId, matchedSector?.name]);

  const prefillBusinessSector = useCallback(() => {
    const isContextOwner =
      upgradeContext.registrationPhoneNumber === userDetailsContext.phoneNumber;

    const sector =
      (isContextOwner && upgradeContext.registrationBusinessSector) ||
      (() => {
        try {
          const storageKey = `${UPGRADE_REG_DETAILS_KEY}_${userDetailsContext.phoneNumber}`;
          const stored = localStorage.getItem(storageKey);
          return stored ? JSON.parse(stored).businessSector : undefined;
        } catch {
          return undefined;
        }
      })();

    if (sector) {
      setFormData((prev) => ({ ...prev, businessSector: sector }));
      setSelectedBusinessSector(sector);
    }

    BusinessApiService.getBusinessDetails()
      .then((response) => {
        const data = response?.data;
        if (!data) return;

        if (data.verificationStatus === "FAILED") {
          setFormData((prev) => ({
            ...prev,
            businessName: data.businessTradingName ?? prev.businessName,
            businessDescription:
              data.businessDescription ?? prev.businessDescription,
            businessSector: data.businessSector ?? prev.businessSector,
            businessType: data.businessType ?? prev.businessType,
          }));
          setSelectedBusinessSector(data.businessSector ?? "");
          setIsResubmissionMode(true);

          BusinessApiService.getBusinessDetailsVerifcationStatus()
            .then((verificationResponse) => {
              const docs = verificationResponse?.data?.documents;
              if (docs) {
                const rejected = docs
                  .filter((doc: any) => doc.status === "REJECTED")
                  .map((doc: any) => (doc.SpFileId as string).split("/")[1]);
                setRejectedDocumentTypes(rejected);
              }
            })
            .catch(console.error);
        } else {
          if (data.businessSector) {
            setFormData((prev) => ({
              ...prev,
              businessSector: data.businessSector ?? prev.businessSector,
            }));
            setSelectedBusinessSector(data.businessSector ?? "");
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching business details:", error);
      });
  }, [upgradeContext, userDetailsContext.phoneNumber]);

  useEffect(() => {
    prefillBusinessSector();

    UsersApiService.getRegistrationDetailsVerificationStatus()
      .then((response: ApiResponseDTORegistrationDetailsRequestDTO) => {
        const legalName = response?.data?.legalName;
        if (legalName) {
          setFormData((prev) => ({ ...prev, businessName: legalName }));
        }
      })
      .catch((error) => {
        console.error("Error fetching registration details:", error);
      });

    BusinessApiService.getBusinessSectors(1, 500)
      .then((response: ApiResponseDTOBusinessSectorsResponseDTO) => {
        if (
          "data" in response &&
          response.data &&
          response.data.businessSectors
        ) {
          const items = response.data.businessSectors.map(
            (sector: BusinessSectorDTO) => ({
              value: sector.name as string,
              label: sector.name as string,
            })
          );
          setBusinessSectorItems(items);
          setBusinessSectorData(response.data.businessSectors);
        }
      })
      .catch((error) => {
        console.error("Error fetching business sectors:", error);
        return error;
      });

    BusinessApiService.getBusinessTypes()
      .then((response: ApiResponseDTOListBusinessTypeDTO) => {
        if ("data" in response && response.data) {
          // Business requirement: only show Sole Proprietorship
          const soleProprietorshipOnly = response.data.filter(
            (type: BusinessTypeDTO) => type.typeValue === "SOLE_PROPRIETORSHIP"
          );

          // const items = response.data.map((type: BusinessTypeDTO) => ({
          //   value: type.typeValue as string,
          //   label: type.typeName as string,
          // }));
          // setBusinessTypeData(response.data);
          setBusinessTypeData(soleProprietorshipOnly);

          // Auto-select Sole Proprietorship as default
          if (soleProprietorshipOnly.length > 0) {
            const defaultType = soleProprietorshipOnly[0];
            setSelectedBusinessType(defaultType.typeValue as string);
            setFormData((prev) => ({
              ...prev,
              businessType: defaultType.typeValue as string,
            }));
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching business types:", error);
        return error;
      });
  }, []);

  useEffect(() => {
    if (upgradeContext.businessLegalName && !formData.businessName) {
      setFormData((prev: FormDataFields) => ({
        ...prev,
        businessName: upgradeContext.businessLegalName || "",
      }));
    }
  }, [upgradeContext.businessLegalName]);

  const onFieldChange = (field: keyof FormDataFields, value: string) => {
    if (field === "businessName" || field === "businessDescription") {
      value = value.replace(ONLY_CHARACTERS_NUMBERS_AND_SPACES_REGEX, "");
    }

    setFormData((prevFormData: FormDataFields) => ({
      ...prevFormData,
      [field]: value,
    }));

    setFormErrors((prevFormErrors: FormErrorsType) => ({
      ...prevFormErrors,
      [field]: { message: "", hasError: false },
    }));
  };

  const onAutocompleteChange = (value: string, _label: string) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      businessSector: value,
    }));

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      businessSector: { message: "", hasError: false },
    }));

    if (value !== selectedBusinessSector) setSelectedSubCategoryId("");
    setSelectedBusinessSector(value);
  };

  const onFieldBlur = (field: keyof FormDataFields) => {
    const formDataField = formData[field];
    if (formDataField === undefined) return;
    handleFormErrors(field, formDataField);
  };

  const handleFormErrors = (field: keyof FormDataFields, value: string) => {
    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [field]: validateField(field, value),
    }));
  };

  const validateField = (
    field: keyof FormDataFields,
    value: string
  ): { hasError: boolean; message: string } => {
    switch (field) {
      case "businessDescription":
        return setBusinessDescriptionValidations(value);
      case "businessSector":
        return setBusinessSectorValidations(value);
      default:
        console.warn("Field not found");
    }
    return { hasError: value.trim() === "", message: "This field is required" };
  };

  const EDITABLE_FIELDS: Array<keyof FormDataFields> = [
    "businessDescription",
    "businessSector",
  ];

  const isFormValid = (): boolean =>
    EDITABLE_FIELDS.every(
      (field) => formData[field] !== "" && !formErrors[field].hasError
    ) &&
    !isLoadingSubCategories &&
    Boolean(selectedSubCategory);

  const areRequiredDocumentsUploaded = (): boolean => {
    if (!matchedType) return false;

    const requiredDocuments: string[] = [];

    if (matchedType.uploadDocuments) {
      requiredDocuments.push(...matchedType.uploadDocuments);
    }

    if (isScrumLRequired) {
      requiredDocuments.push("SCUML Certificate");
    }

    if (requiredDocuments.length === 0) return true;

    // In resubmission mode, only rejected documents need to be re-uploaded
    const docsToCheck = isResubmissionMode
      ? requiredDocuments.filter((doc) => {
          const docType = mapStringToDocumentType(doc);
          return (
            docType !== undefined &&
            rejectedDocumentTypes.includes(docType as string)
          );
        })
      : requiredDocuments;

    if (docsToCheck.length === 0) return true;

    return docsToCheck.every((requiredDoc) => {
      const documentType = mapStringToDocumentType(requiredDoc);
      if (!documentType) return false;
      return documentsArray.some(
        (document) => document.documentType === documentType
      );
    });
  };

  const mapStringToDocumentType = (
    document: string
  ): DocumentDetailsRequestDTO.documentType | undefined => {
    switch (document) {
      case "Certificate of Incorporation":
        return DocumentDetailsRequestDTO.documentType
          .CERTIFICATE_OF_INCORPORATION;
      case "Application for Registration":
        return DocumentDetailsRequestDTO.documentType
          .APPLICATION_FOR_REGISTRATION;
      case "Business License (optional)":
        return DocumentDetailsRequestDTO.documentType.BUSINESS_LICENSE;
      case "Partnership Agreement/Deed":
        return DocumentDetailsRequestDTO.documentType
          .PARTNERSHIP_AGREEMENT_DEED;
      case "Board Resolution":
        return DocumentDetailsRequestDTO.documentType.BOARD_RESOLUTION;
      case "Memat":
        return DocumentDetailsRequestDTO.documentType.MEMAT;
      case "Copy of Rules / Constitution":
        return DocumentDetailsRequestDTO.documentType
          .COPY_OF_RULES_CONSTITUTION;
      case "Resolution Letter Signed by the President":
        return DocumentDetailsRequestDTO.documentType
          .RESOLUTION_LETTER_SIGNED_BY_PRESIDENT;
      case "SCUML Certificate":
        return DocumentDetailsRequestDTO.documentType.SCUML_CERTIFICATE;
      default:
        return undefined;
    }
  };

  const deleteImage = (document: string) => {
    const documentType = mapStringToDocumentType(document);
    if (!documentType) return;

    const filteredImages = documentsArray.filter(
      (doc) => doc.documentType !== documentType
    );

    setDocumentsArray(filteredImages);
  };

  const getImage = (image: File | null, document: string) => {
    if (!image) return;

    const documentType = mapStringToDocumentType(document);
    if (!documentType) return;

    const reader = new FileReader();

    reader.readAsDataURL(image);

    reader.onload = function () {
      const imageContent = reader.result;

      if (!imageContent) return;

      setDocumentsArray((prevDocumentsArray) => {
        const updatedDocumentsArray = [...prevDocumentsArray];

        const index = updatedDocumentsArray.findIndex(
          (doc) => doc.documentType === documentType
        );

        if (index > -1) {
          updatedDocumentsArray[index].contents = [imageContent as string];
          updatedDocumentsArray[index].mimeExt = getFileExtension(image);
        } else {
          const mimeExt = getFileExtension(image);
          updatedDocumentsArray.push({
            documentType,
            contents: [removeBase64Prefix(imageContent as string, mimeExt)],
            mimeExt,
          });
        }

        return updatedDocumentsArray;
      });
    };
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    if (!isFormValid() || !areRequiredDocumentsUploaded()) {
      console.log("Form validation failed or documents missing");
      return;
    }

    setIsContinueDisabled(true);
    setBusinessDetailsStartPage(true);
    setBusinessDetailsValidationTrigger(false);

    const request: BusinessDetailsNigeriaDTO = {
      businessTradingName: formData.businessName,
      businessDescription: formData.businessDescription,
      businessType: formData.businessType,
      businessSector: formData.businessSector,
      sectorId: matchedSector?.sectorId?.toString(),
      subCategoryId: selectedSubCategory?.subCategoryId,
      mccCode: selectedSubCategory?.mccCode || matchedSector?.mccCode || "",
      requireScuml:
        selectedSubCategory?.requiresScuml ??
        matchedSector?.requiresScuml ??
        false,
      documents: documentsArray,
    };

    BusinessApiService.saveBusinessDetails(request)
      .then((_response: ApiResponseDTOBusinessDetailsResponseDTO) => {
        setIsContinueDisabled(false);
        setBusinessDetailsStartPage(false);
        setBusinessDetailsValidationTrigger(true);
      })
      .catch((error) => {
        setIsContinueDisabled(false);

        const errorCode =
          error?.data?.data || error?.response?.data?.data || error?.data;

        if (errorCode === "1015") {
          setHas1015Error(true);
          const tierStepsUpdated: TierStepsResponseDTO[] = updateTierStepStatus(
            upgradeContext,
            TierStepsResponseDTO.stepName.BUSINESS_DETAILS_STEP,
            TierStepsResponseDTO.stepStatus.APPROVED
          );

          setUpgradeContext({
            ...upgradeContext,
            tierSteps: tierStepsUpdated,
          });

          goToNextOpenStep();
        } else {
          setBusinessDetailsStartPage(false);
          setBusinessDetailsValidationTrigger(true);
        }
      });
  };

  const handleModalState = () => {
    setBackModal(!backModal);
  };

  const handleDiscardUpgrade = () => {
    TierApiService.discardUpgradeTier()
      .then((response: ApiResponseDTODiscardUpgradeResponseDTO) => {
        if ("data" in response && response.data) {
          const storageKey = `${UPGRADE_REG_DETAILS_KEY}_${userDetailsContext.phoneNumber}`;
          localStorage.removeItem(storageKey);
          setActiveStep(0);
          clearUpgradeContext();
          navigateTo(UPGRADE_ACCOUNT);
        }
      })
      .catch((error) => {
        console.error("Error discarding upgrade:", error);
        return error;
      });
  };

  const handleContinueButton = () => {
    goToNextOpenStep();
  };

  const handleTryAgain = () => {
    setFormData({
      businessName: "",
      businessDescription: "",
      businessType: "",
      businessSector: "",
    });
    setBusinessDetailsValidationTrigger(false);
    setVerifyingBusinessDetails(true);
    setBusinessDetailsStatus(undefined);
    setBusinessDetailsStartPage(true);
    setIsMatchedType(false);
    setIsMatchedSector(false);
    setMatchedType(undefined);
    setMatchedSector(undefined);
    setSelectedSubCategoryId("");
    setDocumentsArray([]);
    setHas1015Error(false);
    setIsResubmissionMode(false);
    setRejectedDocumentTypes([]);
    prefillBusinessSector();
  };

  const fetchData = useCallback(
    () => BusinessApiService.getBusinessDetailsVerifcationStatus(),
    []
  );
  const { response, error: pollingError } = usePolling(
    businessDetailsValidationTrigger && !has1015Error,
    !verifyingBusinessDetails,
    fetchData
  );

  useEffect(() => {
    if (response) {
      const responseData = (
        response as ApiResponseDTOBusinessDetailsResponseDTO
      ).data;
      const status = responseData?.verificationStatus;

      const extendedData = responseData as ExtendedBusinessDetailsResponseDTO;
      const statusCode = extendedData?.verificationStatusCode || null;
      setVerificationStatusCode(statusCode);

      setVerifyingBusinessDetails(false);

      setBusinessDetailsStatus(status);

      const finalStatus =
        status?.mapUpgradeStatus() as TierStepsResponseDTO.stepStatus;

      const tierStepsUpdated: TierStepsResponseDTO[] = updateTierStepStatus(
        upgradeContext,
        TierStepsResponseDTO.stepName.BUSINESS_DETAILS_STEP,
        finalStatus
      );

      setUpgradeContext({
        ...upgradeContext,
        tierSteps: tierStepsUpdated,
      });
    }
  }, [response]);

  useEffect(() => {
    if (pollingError) {
      setVerifyingBusinessDetails(false);

      setBusinessDetailsStatus(TierStepsResponseDTO.stepStatus.REJECTED);
    }
  }, [pollingError]);

  return (
    <>
      <ModalComponent
        body="Are you sure you want to leave?"
        secondLine="All information provided will be lost."
        title="Discard Upgrade"
        showModal={backModal}
        onClickClose={handleModalState}
        doubleOptions={true}
        onLeftButtonClick={handleDiscardUpgrade}
        onRightButtonClick={handleModalState}
        leftButtonText="Discard Upgrade"
        rightButtonText="Return to Upgrade"
      />
      {businessDetailsStartPage ? (
        <form onSubmit={handleSubmit}>
          <div className="mb-12 overflow-hidden">
            <h5 className="my-4 text-4xl font-medium">Business Details</h5>
            <div className="min-w-0 text-base text-neutral-600">
              Kindly use your business legal information only
            </div>
          </div>

          <div className="mt-5 flex flex-col gap-y-7">
            <div>
              <TextFieldComponent
                id="businessDescription"
                label="Business Description"
                labelId="businessDescriptionLabel"
                type="text"
                placeholder="Enter a description with a maximum of 150 characters"
                value={formData.businessDescription}
                hasError={formErrors.businessDescription.hasError}
                onChange={(e) =>
                  onFieldChange("businessDescription", e.currentTarget.value)
                }
                onBlur={() => onFieldBlur("businessDescription")}
                maxLength={150}
              />
              {formErrors.businessDescription.hasError && (
                <div className="mt-1 ml-2 text-xs text-red-800">
                  <span className="break-words">
                    {formErrors.businessDescription.message}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="mt-5 flex flex-col gap-y-7">
            <div>
              <AutocompleteComponent
                selectValue={
                  formData.businessSector
                    ? {
                        value: formData.businessSector,
                        label: formData.businessSector,
                      }
                    : null
                }
                id="businessSector"
                label="Business Sector"
                labelId="businessSectorLabel"
                className={`w-full rounded-xl ${
                  formErrors.businessSector.message ? "border-red-500" : ""
                }`}
                placeholder="Select business sector"
                onChange={onAutocompleteChange}
                onBlur={() => onFieldBlur("businessSector")}
                options={businessSectorItems}
                noOptionsText="No Sectors Found"
                showSearchIcon
              />
              {formErrors.businessSector.hasError && (
                <div className="mt-1 ml-2 text-xs text-red-800">
                  <span className="break-words">
                    {formErrors.businessSector.message}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="mt-5 flex flex-col gap-y-7">
            <SelectComponent
              id="business-sub-category-select"
              labelId="business-sub-category-select-label"
              label="Business Sector Sub-Category"
              placeholder="Select Option"
              className="w-auto"
              items={subCategories.map((subCategory) => ({
                value: String(subCategory.subCategoryId),
                label: subCategory.subCategoryName ?? "",
              }))}
              value={selectedSubCategoryId}
              onChange={(_, value) => setSelectedSubCategoryId(value ?? "")}
              disabled={!matchedSector || isLoadingSubCategories}
            />
          </div>

          <div>
            {isMatchedType &&
              // isMatchedSector &&
              matchedType?.uploadDocuments &&
              matchedType.uploadDocuments
                .filter((document) => document !== "SCUML Certificate")
                .map((document, index) => (
                  <>
                    {index === 0 && (
                      <div className="my-8">
                        <h4 className="mb-1 text-lg font-bold">
                          Upload Documents
                        </h4>
                        <p className="text-sm font-extralight text-neutral-400">
                          Maximum file size is 10MB. Supported file types are
                          JPEG, PNG and PDF. Ensure the document is still valid.
                        </p>
                      </div>
                    )}
                    <div className="mb-6" key={index}>
                      {isResubmissionMode &&
                      !rejectedDocumentTypes.includes(
                        mapStringToDocumentType(document) as string
                      ) ? (
                        <div>
                          <div className="mb-2 flex items-center gap-x-1">
                            <CheckCircle fill="#6EBD7F" />
                            <span className="text-sm text-accent-success">
                              {document}
                            </span>
                          </div>
                          <div className="flex h-12 w-full items-center justify-between rounded-lg bg-neutral-25 px-4">
                            <p className="text-sm text-neutral-600">
                              Previously approved
                            </p>
                            <CheckCircle fill="#6EBD7F" />
                          </div>
                        </div>
                      ) : (
                        <DropZoneComponent
                          fieldName={document}
                          getImage={(image: File | null) =>
                            getImage(image, document)
                          }
                          deleteImage={() => deleteImage(document)}
                          acceptedFileTypes={["jpeg", "png", "pdf"]}
                          acceptedMinSize={MIN_SIZE_BACK_OFFICE}
                          fileInvalidTypeErrorMessage={
                            FILE_INVALID_TYPE_BACK_OFFICE
                          }
                          parentFileChangeListener={selectedBusinessType}
                        />
                      )}
                    </div>
                  </>
                ))}
            {isMatchedSector && isScrumLRequired && (
              <div className="mb-6">
                {isResubmissionMode &&
                !rejectedDocumentTypes.includes(
                  mapStringToDocumentType("SCUML Certificate") as string
                ) ? (
                  <div>
                    <div className="mb-2 flex items-center gap-x-1">
                      <CheckCircle fill="#6EBD7F" />
                      <span className="text-sm text-accent-success">
                        SCUML Certificate
                      </span>
                    </div>
                    <div className="flex h-12 w-full items-center justify-between rounded-lg bg-neutral-25 px-4">
                      <p className="text-sm text-neutral-600">
                        Previously approved
                      </p>
                      <CheckCircle fill="#6EBD7F" />
                    </div>
                  </div>
                ) : (
                  <DropZoneComponent
                    fieldName={"SCUML Certificate"}
                    getImage={(image: File | null) =>
                      getImage(image, "SCUML Certificate")
                    }
                    deleteImage={() => deleteImage("SCUML Certificate")}
                    acceptedFileTypes={["jpeg", "png", "pdf"]}
                    acceptedMinSize={MIN_SIZE_BACK_OFFICE}
                    fileInvalidTypeErrorMessage={FILE_INVALID_TYPE_BACK_OFFICE}
                    parentFileChangeListener={selectedBusinessSector}
                  />
                )}
              </div>
            )}
          </div>
          <div className="mt-20 flex flex-col items-start gap-y-4 sm:gap-x-4 lg:flex-row">
            <button
              id="registration-details-discard-button"
              className="secondary-button"
              onClick={handleModalState}
              type="button"
            >
              Discard
            </button>

            <button
              id="continue-button"
              className="primary-button"
              type="submit"
              disabled={
                !isFormValid() ||
                isContinueDisabled ||
                !areRequiredDocumentsUploaded()
              }
            >
              {isContinueDisabled ? (
                <CircularProgress className="text-zinc-600" size={"16px"} />
              ) : (
                "Continue"
              )}
            </button>
          </div>
        </form>
      ) : (
        <div className="mt-6 flex flex-col">
          <h1 className="mb-16 text-4.5xl font-medium text-neutral-900">
            Business Details
          </h1>

          {!verifyingBusinessDetails &&
            (businessDetailsStatus ===
              BusinessDetailsResponseDTO.verificationStatus.PENDING ||
              businessDetailsStatus ===
                TierStepsResponseDTO.stepStatus.PENDING) && (
              <StepStatusComponent
                status={BusinessDetailsResponseDTO.verificationStatus.PENDING}
                title={"Waiting For Approval"}
                subTitle={'Press "Continue" to proceed.'}
                icon={<Clock transform="scale(1.70)" />}
                handleDiscardButton={handleModalState}
                handleContinueButton={handleContinueButton}
              />
            )}

          {!verifyingBusinessDetails &&
            (businessDetailsStatus ===
              BusinessDetailsResponseDTO.verificationStatus.SUCCESS ||
              businessDetailsStatus ===
                TierStepsResponseDTO.stepStatus.APPROVED) && (
              <StepStatusComponent
                status={BusinessDetailsResponseDTO.verificationStatus.SUCCESS}
                title={"Document Successfully Verified"}
                subTitle={'Press "Continue" to proceed.'}
                icon={<CheckCircle transform="scale(1.70)" />}
                handleDiscardButton={handleModalState}
                handleContinueButton={handleContinueButton}
              />
            )}

          {!verifyingBusinessDetails &&
            (businessDetailsStatus ===
              BusinessDetailsResponseDTO.verificationStatus.FAILED ||
              businessDetailsStatus ===
                TierStepsResponseDTO.stepStatus.REJECTED) && (
              <StepStatusComponent
                status={BusinessDetailsResponseDTO.verificationStatus.FAILED}
                title={"Document Verification Failed"}
                subTitle={"Please, try this again."}
                icon={<CloseCircle transform="scale(1.70)" />}
                handleDiscardButton={handleModalState}
                handleTryAgainButton={handleTryAgain}
              />
            )}

          {verifyingBusinessDetails && (
            <div className="flex flex-col items-center">
              <SpinnerComponent size={64} type={"primary"} showIcon={false} />
              <p className="mt-6 text-base font-normal text-neutral-600">
                Your documentation is being verified.
              </p>
              <p className="text-sm font-normal text-neutral-400">
                This should not take too long.
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default BusinessDetailsPage;
